var _mask, _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoCloseSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 26,
    viewBox: "0 0 26 26",
    width: 26,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "a",
    height: 26,
    maskUnits: "userSpaceOnUse",
    width: 26,
    x: 0,
    y: 0
  }, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m19.1283 6.87175c-.2604-.26035-.6825-.26034-.9428 0l-5.1854 5.18545-5.18553-5.1855c-.26035-.26035-.68246-.26035-.9428 0-.26035.26035-.26035.68246-.00001.94281l5.18544 5.18549-5.18543 5.1855c-.26035.2603-.26035.6824 0 .9428.26035.2603.68246.2603.94281 0l5.18552-5.1855 5.1854 5.1854c.2603.2604.6824.2604.9428 0 .2603-.2603.2603-.6824 0-.9428l-5.1854-5.1854 5.1854-5.18544c.2603-.26035.2603-.68246 0-.94281z",
    fill: "#fff",
    fillRule: "evenodd"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m19.1283 6.87175c-.2604-.26035-.6825-.26034-.9428 0l-5.1854 5.18545-5.18553-5.1855c-.26035-.26035-.68246-.26035-.9428 0-.26035.26035-.26035.68246-.00001.94281l5.18544 5.18549-5.18543 5.1855c-.26035.2603-.26035.6824 0 .9428.26035.2603.68246.2603.94281 0l5.18552-5.1855 5.1854 5.1854c.2603.2604.6824.2604.9428 0 .2603-.2603.2603-.6824 0-.9428l-5.1854-5.1854 5.1854-5.18544c.2603-.26035.2603-.68246 0-.94281z",
    fill: "#979797",
    fillRule: "evenodd"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m5 21h16v-16h-16z",
    fill: "#4f8a10",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoCloseSuccess);
export default __webpack_public_path__ + "static/media/ico_close_success.3714681e134558fb1a2554e53fd1a178.svg";
export { ForwardRef as ReactComponent };